<template>
  <transition name="ten-fade-in">
    <div
      v-if="_finishVisible"
      class="ten-backtop"
      :style="{
        right: _offsetRight,
        bottom: _offsetBottom
      }"
      @click="handleClick"
    >
      <!-- @slot 回到顶部内容 -->
      <slot>
        <ten-button
          class="ten-backtop-button"
          theme="default"
          icon="backtop"
          round
          icon-only
        />
      </slot>
    </div>
  </transition>
</template>

<script>
import throttle from 'lodash/throttle';
import TenButton from '../button';
import DomHelper from '../scripts/utils/dom-helper';

const { scrollTo, getScroll } = DomHelper;
const name = 'ten-backtop';

export default {
  name,

  components: {
    TenButton,
  },

  props: {
    /**
     * 触发滚动的对象传字符串选择器，如 '#id .class'
     */
    target: String,

    /**
     * 是否显示，如果有传值则根据该值展示
     */
    visible: {
      type: Boolean,
    },

    /**
     * 滚动高度达到该值才会出现 Backtop
     */
    visiblityHeight: {
      type: Number,
      default: 400,
    },

    /**
     * 按钮距离页面右边距
     */
    right: {
      type: Number,
      default: 40,
    },

    /**
     * 按钮距离页面底部距
     */
    bottom: {
      type: Number,
      default: 40,
    },
  },

  targetEl: null,
  listenEl: null,

  data() {
    return {
      selfVisible: false,
      hadVisible: false,
    };
  },

  computed: {
    _offsetRight() {
      return `${this.right}px`;
    },

    _offsetBottom() {
      return `${this.bottom}px`;
    },

    _finishVisible() {
      return this.hadVisible ? this.visible : this.selfVisible;
    },
  },

  mounted() {
    this.init();
    if (!this.hadVisible) {
      this.throttleHandleScroll = throttle(this.handleScroll, 300);
      this.listenEl.addEventListener('scroll', this.throttleHandleScroll);
    }
  },

  beforeDestroy() {
    this.listenEl.removeEventListener('scroll', this.throttleHandleScroll);
  },

  methods: {
    init() {
      this.targetEl = this.target ? document.querySelector(this.target) : document.documentElement;
      if (!this.targetEl) throw new Error(`ten backtop: 找不到 ${this.target}`);
      this.listenEl = this.targetEl === document.documentElement ? document : this.targetEl;
      this.hadVisible = 'visible' in this.$vnode.componentOptions.propsData;
    },

    handleScroll() {
      const currentScrollTop = getScroll(this.targetEl);
      this.selfVisible = currentScrollTop >= this.visiblityHeight;
    },

    handleClick(event) {
      this.handleScrollTop();
      /**
       * click 事件
       *
       * @param {Object} e 事件对象
       */
      this.$emit('click', event);
    },

    handleScrollTop() {
      scrollTo(this.targetEl);
    },

  },
};
</script>
